import { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { UserContext } from "../providers/userProvider";

const FetchUser = (props) => {
  const [checkDone, setCheckDone] = useState(false);
  const { user, handleLogout, getUser } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    getUserOnRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getUserOnRefresh = async () => {
    if (user.phoneNumber) {
      setCheckDone(true);
      return;
    }

    const storedPhone =
      localStorage.getItem("phoneNumber") ||
      sessionStorage.getItem("phoneNumber");

    if (!storedPhone) {
      if (location.pathname !== "/login") {
        navigate("/login");
      }
      setCheckDone(true);
      return;
    }

    try {
      await getUser(storedPhone);
    } catch (error) {
      // Only force logout on a definitive "user not found" — not on network/server errors
      if (error.response?.status === 404) {
        await handleLogout();
        navigate("/login");
      }
    } finally {
      setCheckDone(true);
    }
  };

  if (checkDone) {
    return props.children;
  }
  return null;
};

export default FetchUser;
